module.exports = __webpack_public_path__ + "nright_white_arrow.png";